import { Injectable } from '@angular/core';

import { StatsigService } from '@services/statsig.service';

export enum SAFETY_FEATURE_FLAGS {
  SAFETY_EVENT_TELEMATICS_BAR = 'safety-event-telematics-bar',
  SAFETY_SPEED_LIMIT_EDITOR = 'safety-speed-limit-editor',
  SAFETY_SCA_REPORTS_ENABLED = 'safety-sca-reports-enabled',
  SAFETY_ADMIN_V2_VEHICLE_SETTINGS_ENABLED = 'safety-admin-v2-vehicle-settings-enabled',
  SAFETY_IN_CAB_AUDIO_RECORDING_SETTING_HIDDEN = 'in-cab-audio-recording-setting-hidden',
  SAFETY_ANNOTATOR_PIPELINE_ENABLED = 'safety-annotator-pipeline-enabled',
  SAFETY_SELECTIVE_BLUR_ENABLED = 'safety-selective-blur-enabled',
  SAFETY_DRIVE_V4_BEHAVIORS_GRAPH_ENABLED = 'safety-drive-v4-behaviors-graph-enabled',
  SAFETY_DRIVE_V4_REPORTS_DATE_PICKER_ENABLED = 'safety-v4-reports-date-picker-enabled',
  SAFETY_DRIVE_V4_REPORTS_UPDATED_SCHEDULING = 'safety-drive-v4-reports-updated-scheduling',
  SAFETY_CAMERA_OBSTRUCTION_INCAB_ALERTS_ENABLED = 'safety-camera-obstruction-incab-alerts-enabled',
  SAFETY_FORWARD_COLLISION_WARNING_ENABLED = 'safety-forward-collision-warning-enabled',
  SAFETY_VG_ONLY_CRASH_EVENTS = 'safety-vg-only-crash-events',
  SAFETY_FORWARD_COLLISION_WARNING_ALERTS_ENABLED = 'safety-forward-collision-warning-alerts-enabled',
  SAFETY_UNSAFE_PARKING_ENABLED = 'safety-unsafe-parking-enabled',
  SAFETY_UNSAFE_PARKING_INCAB_ALERTS_ENABLED = 'safety-unsafe-parking-incab-alerts-enabled',
  SAFETY_ADMIN_V2_EVENTS_TOGGLE_ENABLED = 'safety-admin-v2-events-toggle-enabled',
  SAFETY_CAPPED_EVENT_IMAGE_RECALL_ENABLED = 'safety-capped-event-image-recall-enabled',
  SAFETY_GEOFENCE_SPEEDING_UNIT_CONVERSION_ENABLED = 'safety-geofence-speeding-unit-conversion-enabled',
  SAFETY_POTENTIAL_COLLISION_ALERTS_ENABLED = 'safety-potential-collision-alerts-enabled',
  SAFETY_OMNICAM_DROP_AND_HOOK_ENABLED = 'safety-omnicam-drop-and-hook-enabled',
  SAFETY_PRINTABLE_COACHING_SUMMARY_ENABLED = 'safety-printable-coaching-summary-enabled',
  SAFETY_VG5SW_ENABLED = 'safety-vg5sw-enabled',
  SAFETY_COLLISION_PDF_REPORTS_ENHANCEMENTS_ENABLED='safety-collision-pdf-reports-enhancement-enabled',
  SAFETY_HIDE_STOP_SIGN_VIOLATION = 'safety-hide-stop-sign-violation',
  SAFETY_OC_ASSET_SUPPORT_PHASE_2_ENABLED = 'safety-oc-asset-support-phase-2-enabled',
  SAFETY_ZONE_DETECTION_ENABLED = 'safety-zone-detection-enabled',
  SAFETY_SPEEDING_VRR_ENABLED = 'safety-speeding-vrr-enabled',
  SAFETY_EVENTS_INCAB_ALERTS_ENABLED = 'safety-events-incab-alerts-enabled',
  SAFETY_FILTERS_PERSISTENCE_ENABLED = 'fe-platform-filters-persistence-safety',
  SAFETY_ENABLE_VG_DISCONNECT_DASHCAM_STATUS = 'safety-enable-vg-disconnect-dashcam-status',
  SAFETY_AI_GENERIC_FRAMEWORK_ENABLED = 'safety-ai-generic-framework-enabled',
  SAFETY_COLLISION_POC_ENABLED = 'safety-collision-poc-enabled',
  SAFETY_AUDIT_LOG_ENABLED = 'safety-audit-log-enabled',
  SAFETY_WEB_HEVC_URL_SUPPORT_ENABLED = 'safety-web-hevc-url-support-enabled',
  SAFETY_UNSAFE_BEHAVIORS_REMOVE_PRESETS = 'safety-unsafe-behaviors-remove-presets',
  SAFETY_CAMERA_SUMMARY_REPORT_ENABLED = 'safety-camera-summary-report-enabled',
  SAFETY_SHOW_DATA_RETENTION_SETTINGS = 'safety-show-data-retention-settings',
  SAFETY_COMMENDABLE_BEHAVIOR_VIDEO_TAG_ENABLED = 'safety-commendable-behavior-video-tag-enabled',
  SAFETY_LANE_SWERVING_EVENTS_ENABLED = 'safety-lane-swerving-events-enabled',
  SAFETY_LANE_SWERVING_INCAB_ALERTS_ENABLED = 'safety-lane-swerving-incab-alerts-enabled',
  SAFETY_SMOKING_EVENTS_ENABLED = 'safety-ai-smoking-events-enabled',
  SAFETY_SMOKING_INCAB_ALERTS_ENABLED = 'safety-ai-smoking-alerts-enabled',
  SAFETY_PLAY_HYPERLAPSE_VIDEOS_FASTER = 'safety-play-hyperlapse-videos-faster',
  SAFETY_INCAB_ALERT_UDE_MODE_OVERRIDABLE_ENABLED = 'safety-incab-alert-ude-mode-overridable-enabled',
  SAFETY_SPEEDING_EMAIL_ALERTS_V2_ENABLED = 'safety_speeding_email_alerts_v2_enabled',
  SAFETY_SPEEDING_EMAIL_ALERTS_V2_WITH_CUSTOM = 'safety_speeding_email_alerts_v2_with_custom',
  SAFETY_VRR_RABL_OPTIMIZATION_ENABLED = 'safety-vrr-rabl-optimization-enabled',
  SAFETY_SIDE_CAM_HYPERLAPSE_CAPABLE_ENABLED = 'safety-side-cam-hyperlapse-capable-enabled',
  SAFETY_EVENTS_TRIMMED_T2H_VALUES_EDEE_5418 = 'safety-events-trimmed-t2h-values-edee-5418',
  SAFETY_REMOVE_OVERWRITTEN_VRR_TIME_ENABLED = 'safety-remove-overwritten-vrr-time-enabled',
  SAFETY_CONFIDENTIAL_EVENTS_ENABLED = 'safety-confidential-events-enabled',
  SAFETY_AI_RECAP_ENABLED = 'safety-ai-recaps-enabled',
  SAFETY_VRR_10MIN_NORMAL_ENABLED = 'safety-vrr-10min-normal-enabled',
  SAFETY_VRR_10MIN_NORMAL_V2_ENABLED = 'safety-vrr-10min-normal-v2-enabled',
  SAFETY_EVENTS_REFRESH_V2_ENABLED = 'safety-events-refresh-v2-enabled',
  SAFETY_FXG_CONTRACTOR_ENABLED = 'safety-partner-sync-enabled',
  SAFETY_EVENTS_AI_SUMMARY_INSIGHTS_ENABLED = 'safety-events-ai-summary-insights-enabled',
  SAFETY_VIDEO_REQUESTS_STATUS_ENABLED = 'safety-detailed-video-recall-request-status-enabled',
  SAFETY_PRIVACY_BLURRING_ENABLED = 'safety-privacy-blurring-enabled',
  SAFETY_OMNICAM_ISSUES_COUNT_VISIBLE = 'safety-omnicam-issues-count-visible',
}

@Injectable({ providedIn: 'root' })
export class SafetyFeatureFlagService {

  constructor(private statsigService: StatsigService) {}

  public isEventTelematicsFeatureEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_EVENT_TELEMATICS_BAR);
  }

  public isSpeedLimitEditorEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_SPEED_LIMIT_EDITOR);
  }

  public isSCAReportsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_SCA_REPORTS_ENABLED);
  }

  public isSafetyAdminV2VehicleSettingsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_ADMIN_V2_VEHICLE_SETTINGS_ENABLED);
  }

  public isSafetyAdminV2EventsToggleEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_ADMIN_V2_EVENTS_TOGGLE_ENABLED);
  }

  public isIncabAudioRecordingSettingHidden(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_IN_CAB_AUDIO_RECORDING_SETTING_HIDDEN);
  }

  public isAnnotatorPipelineEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_ANNOTATOR_PIPELINE_ENABLED);
  }

  public isDriveV4BehaviorsGraphEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_DRIVE_V4_BEHAVIORS_GRAPH_ENABLED);
  }

  public isDriveV4ReportsDatePickerEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_DRIVE_V4_REPORTS_DATE_PICKER_ENABLED);
  }

  public isCameraObstructionIncabAlertsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_CAMERA_OBSTRUCTION_INCAB_ALERTS_ENABLED);
  }

  public isFCWEventsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_FORWARD_COLLISION_WARNING_ENABLED);
  }

  public isVGOnlyCrashEventsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_VG_ONLY_CRASH_EVENTS);
  }

  public isFCWIncabAlertsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_FORWARD_COLLISION_WARNING_ALERTS_ENABLED);
  }

  public isUnsafeParkingEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_UNSAFE_PARKING_ENABLED);
  }

  public isUnsafeParkingIncabAlertsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_UNSAFE_PARKING_INCAB_ALERTS_ENABLED);
  }

  public isSafetyCappedEventImageRecallEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_CAPPED_EVENT_IMAGE_RECALL_ENABLED);
  }

  public isGeofenceSpeedingUnitConversionEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_GEOFENCE_SPEEDING_UNIT_CONVERSION_ENABLED);
  }

  public isPotentialCollisionAlertsEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_POTENTIAL_COLLISION_ALERTS_ENABLED);
  }

  public isOmnicamDropAndHookEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_OMNICAM_DROP_AND_HOOK_ENABLED);
  }

  public isShareWithDriverBtnHidden(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_PRINTABLE_COACHING_SUMMARY_ENABLED);
  }

  public isVG5SWEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_VG5SW_ENABLED);
  }

  public isCollisionPdfReportsEnhancementEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_COLLISION_PDF_REPORTS_ENHANCEMENTS_ENABLED);
  }

  public isDriveV4ReportsUpdatedSchedulingEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_DRIVE_V4_REPORTS_UPDATED_SCHEDULING);
  }

  public isHideStopSignViolationEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_HIDE_STOP_SIGN_VIOLATION);
  }

  public isOCAssetSupportPhase2Enabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_OC_ASSET_SUPPORT_PHASE_2_ENABLED);
  }

  public isZoneDetectionEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_ZONE_DETECTION_ENABLED);
  }

  public isVrrOnSpeedingDetailPageEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_SPEEDING_VRR_ENABLED);
  }

  public isSafetyEventsIncabAlertsEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_EVENTS_INCAB_ALERTS_ENABLED);
  }

  public isSafetyFiltersPersistenceEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_FILTERS_PERSISTENCE_ENABLED);
  }

  public isVGDisconnectedStatusEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_ENABLE_VG_DISCONNECT_DASHCAM_STATUS);
  }

  public isAIGenericFrameworkEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_AI_GENERIC_FRAMEWORK_ENABLED);
  }

  public isAuditLogEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_AUDIT_LOG_ENABLED);
  }

  public isSafetyDataRetentionSettingsVisible(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_SHOW_DATA_RETENTION_SETTINGS);
  }

  public isCollisionReportContactEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_COLLISION_POC_ENABLED);
  }

  public isWebHEVCUrlSupportEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_WEB_HEVC_URL_SUPPORT_ENABLED);
  }

  public isUnsafeBehaviorsRemovePresetsEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_UNSAFE_BEHAVIORS_REMOVE_PRESETS);
  }

  public isSafetyEventsTrimmedT2HValuesEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_EVENTS_TRIMMED_T2H_VALUES_EDEE_5418);
  }

  public isCameraReportV2Enabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_CAMERA_SUMMARY_REPORT_ENABLED);
  }

  public isPositiveBehaviorTagsEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_COMMENDABLE_BEHAVIOR_VIDEO_TAG_ENABLED);
  }

  public isPlayHyperlapseVideosFasterEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_PLAY_HYPERLAPSE_VIDEOS_FASTER);
  }

  public isLaneSwervingEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_LANE_SWERVING_EVENTS_ENABLED);
  }

  public isLaneSwervingIncabAlertsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_LANE_SWERVING_INCAB_ALERTS_ENABLED);
  }

  public isSmokingEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_SMOKING_EVENTS_ENABLED);
  }

  public isSmokingIncabAlertsEnabled(): boolean {
    return this.statsigService
      .evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_SMOKING_INCAB_ALERTS_ENABLED);
  }

  public isRemoveOverwrittenVRRTimeEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_REMOVE_OVERWRITTEN_VRR_TIME_ENABLED);
  }

  public isSelectiveBlurEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_SELECTIVE_BLUR_ENABLED);
  }

  public isIncabAlertUdeModeOverridableEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_INCAB_ALERT_UDE_MODE_OVERRIDABLE_ENABLED);
  }

  public isSpeedingEmailAlertsV2Enabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_SPEEDING_EMAIL_ALERTS_V2_ENABLED);
  }

  public isSpeedingEmailAlertsV2WithCustomEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_SPEEDING_EMAIL_ALERTS_V2_WITH_CUSTOM);
  }

  public isConfidentialEventsEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_CONFIDENTIAL_EVENTS_ENABLED);
  }

  public isSafetyVrrRablOptimizationEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_VRR_RABL_OPTIMIZATION_ENABLED);
  }

  public isSafetySideCamHyperlapseCapableEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_SIDE_CAM_HYPERLAPSE_CAPABLE_ENABLED);
  }

  public isSafetyAICoachEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_AI_RECAP_ENABLED);
  }

  public is10MinRecallEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_VRR_10MIN_NORMAL_ENABLED) ||
           this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_VRR_10MIN_NORMAL_V2_ENABLED);
  }

  public isSafetyEventsRefreshV2Enabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_EVENTS_REFRESH_V2_ENABLED);
  }

  public isFXGContractorEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_FXG_CONTRACTOR_ENABLED);
  }

  public isEventsAISummaryInsightsEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_EVENTS_AI_SUMMARY_INSIGHTS_ENABLED);
  }

  public isDetailedVRRStatusEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_VIDEO_REQUESTS_STATUS_ENABLED);
  }

  public isSafetyPrivacyBlurringEnabled(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_PRIVACY_BLURRING_ENABLED);
  }

  public isOmnicamIssuesCountVisible(): boolean {
    return this.statsigService.evaluateGate(SAFETY_FEATURE_FLAGS.SAFETY_OMNICAM_ISSUES_COUNT_VISIBLE);
  }
}
